import { render } from "./CNAMDelete.vue?vue&type=template&id=6dad6130"
import script from "./CNAMDelete.vue?vue&type=script&lang=js"
export * from "./CNAMDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__